export default __webpack_public_path__ + "static/media/error.9025cf57.wav";